var Locale = {

    get: function () {
        var resStr = Locale.getNonEscape.apply(null, arguments);
        if(typeof resStr === 'string'){
            resStr = resStr.escape();
        }
    	return resStr;
    },

    getNonEscape: function () {
        if (typeof(LANG) == 'undefined') {
            LANG = {};
        }
        var str = arguments[0];
        if (LANG[str]) {
            str = LANG[str];
        }

        if(arguments.length > 1) {
            arguments[0] = str;
            str = sprintf.apply(null, arguments);
        }

        return str;
    },

    has: function (key) {
        if (typeof(LANG) !== 'undefined' && LANG[key]) {
            return true;
        }
        return false;
    },

    getWithVars: function (str, data) {
        var res = Locale.getNonEscape(str);
        for (var key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            var stringToReplace = new RegExp("%"+key+"%", "g");
            res = res.replace(stringToReplace, data[key]);
        }
        return res;
    }

};
define("utils.locale", ["utils.string"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Locale;
    };
}(this)));

